import React, { useEffect } from "react"
import { Form } from "antd"

import CustomFormItem from "../../../v2-components/Antd/FormItem"
import CustomSwitch from "../../../v2-components/Antd/Switch"
import CustomInput from "../../../v2-components/Antd/Input"
import CustomSelect from "../../../v2-components/Antd/Select"

import { ROLES } from "../constants/index"

import "../styles/common.css"
import "../styles/forms.css"

const UpdateUserForm = ({ values = {} }) => {
    const [form] = Form.useForm()

    // Actualizar formulario cuando cambian los valores
    useEffect(() => {
        form.setFieldsValue(values)
    }, [values, form])

    return (
        <div className="page-container">
            <Form form={form} layout="vertical" className="form-container">
                <h2 className="section-title">Datos</h2>

                {/* ID - Oculto al usuario */}
                <CustomInput name="id" type="hidden" value={values.id} />

                {/* Correo electrónico */}
                <CustomFormItem label="Correo electrónico" name="email" className="form-item">
                    <CustomInput disabled placeholder="Correo electrónico" />
                </CustomFormItem>

                {/* Primer nombre */}
                <CustomFormItem label="Nombre" name="first_name" className="form-item">
                    <CustomInput disabled placeholder="Nombre" />
                </CustomFormItem>

                {/* Apellido */}
                <CustomFormItem label="Apellido" name="last_name" className="form-item">
                    <CustomInput disabled placeholder="Apellido" />
                </CustomFormItem>

                <h2 className="section-title">Roles</h2>

                {/* Roles */}
                <Form.Item
                    label="Rol de usuario"
                    name="roles"
                    rules={[{ required: true, message: "Por favor selecciona un rol" }]}
                    className="form-item"
                >
                    <CustomSelect disabled placeholder="Selecciona un rol">
                        {ROLES.filter((option) => option.value !== "admin").map((option) => (
                            <CustomSelect.Option key={option.key} value={option.value}>
                                {option.label}
                            </CustomSelect.Option>
                        ))}
                    </CustomSelect>
                </Form.Item>

                <h2 className="section-title">
                    Sucursal
                </h2>

                {/* Sucursales */}
                <Form.Item
                    label="Sucursal"
                    name="pharmacy"
                    rules={[{ required: true, message: "Por favor selecciona una sucursal" }]}
                    className="form-item"
                >
                    <CustomSelect
                        placeholder="Selecciona una sucursal"
                        disabled
                    >
                        <CustomSelect.Option key={values.pharmacy} value={values.pharmacy}>
                            {values.pharmacy}
                        </CustomSelect.Option>
                    </CustomSelect>
                </Form.Item>
                <h2 className="section-title">Estado</h2>

                {/* Estado de habilitación */}
                <CustomFormItem label="Estado" name="eneable" valuePropName="checked" className="form-item">
                    <CustomSwitch disabled />
                </CustomFormItem>
            </Form>
        </div>
    )
}

export default React.memo(UpdateUserForm)

